import { useEffect } from "react";
import "./Dashboard.css";
import DashboardMain from "../../components/dashboard/DashboardMain/DashboardMain";
import HeaderClientAdmin from "../../components/HeaderClientAdmin/HeaderClientAdmin";
import { useNavigate } from "react-router-dom";
import { GetSessionStorageData } from "../../utilities/helper";
import { TOKENS } from "../../utilities/Constants/Constants";
import { useDispatch } from "react-redux";
import { setActiveCard } from "../../service/apiSlices/staticApi";

const Dashboard = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch()

  useEffect(() => {
     sessionStorage.removeItem("modelCompleted")
     sessionStorage.setItem("activeCard", "");
     dispatch(setActiveCard(""))
    const handlePopState = () => {
      const accessToken = GetSessionStorageData(TOKENS.ACCESS_TOKEN);
      if (accessToken) {
        window.history.pushState(null, '', '/dashboard');
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  return (
    <>
      <HeaderClientAdmin pageTitle='Home' config={{ showSearch: true, showInviteTeam: true }} />
      <div className="page-container">
        <div className="row">
          <div className="col-md-12">
            <div className="dashboard-content">
              <DashboardMain />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
